import { render, staticRenderFns } from "./UploadImg-ai.vue?vue&type=template&id=754e6ba6&scoped=true"
import script from "./UploadImg-ai.vue?vue&type=script&lang=ts"
export * from "./UploadImg-ai.vue?vue&type=script&lang=ts"
import style0 from "./UploadImg-ai.vue?vue&type=style&index=0&id=754e6ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754e6ba6",
  null
  
)

export default component.exports